import { cn } from '@/lib/tailwind.utils'

interface SectionHeadingProps {
  children: React.ReactNode
  className?: string
}

const SectionHeading = ({ children, className }: SectionHeadingProps) => {
  return <h2 className={cn('text-base font-semibold text-primary py-4', className)}>{children}</h2>
}

export default SectionHeading
